const localizedName = (name) => name?.ru;
/** Значение поля одной строкой (для названий, таблиц, экспорта). Пустое — ''. */
export function formatPlain(meta, def, value, resolveRef) {
    if (value === undefined || value === null || value === '')
        return '';
    switch (def.dataType) {
        case 'year_range': {
            const r = value;
            return r.to === undefined || r.to === null || r.to === r.from
                ? String(r.from)
                : `${r.from}–${r.to}`;
        }
        case 'enum':
            return (localizedName(meta.enums[def.enumSet ?? '']?.find((o) => o.code === value)?.name) ??
                String(value));
        case 'multi_enum':
            return value
                .map((code) => localizedName(meta.enums[def.enumSet ?? '']?.find((o) => o.code === code)?.name) ??
                code)
                .join(', ');
        case 'ref':
            return resolveRef?.(def.refKind ?? '', String(value)) ?? '';
        case 'money': {
            const m = value;
            return `${m.amount} ${m.currency}`;
        }
        case 'grade': {
            const g = value;
            return g.value;
        }
        case 'boolean':
            return value ? 'да' : 'нет';
        case 'decimal':
            return String(value).replace('.', ',');
        case 'list':
            return value
                .map((item) => {
                const n = item;
                return typeof item === 'object' && item !== null && n.number
                    ? `${n.system} ${n.number}`
                    : String(item);
            })
                .join('; ');
        default:
            return String(value);
    }
}
//# sourceMappingURL=format.js.map